// Styles
import './breadcrumbs.scss';
if (!window.dAgency) window.dAgency = {};
window.dAgency.initBreadcrumbs = (context) => {
  const breadcrumbs = context.closest('.shopify-section');
  const breadcrumbsRoot = breadcrumbs.querySelector('[data-breadcrumbs-root]');
  const takeMeBack = document.querySelector('.take-me-back');
  if (breadcrumbsRoot && takeMeBack) {
    const bcNodeElements = breadcrumbsRoot.children;
    if (bcNodeElements && bcNodeElements.length) {

      const bcElements = Array.from(bcNodeElements).filter(bcEl => !(bcEl.classList.contains('breadcrumbs__separator')));
      if (bcElements.length >= 2) {
        const previousPage = bcElements.reverse()[1];
        if (previousPage.nodeName !== 'A') return;
        takeMeBack.href = previousPage.href;
        takeMeBack.innerText = previousPage.innerText;
        takeMeBack.style.display = 'flex';
      }

    }
  }
}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.breadcrumbs__container'), (el) => {
    window.dAgency.initBreadcrumbs(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.breadcrumbs__container'), (el) => {
      window.dAgency.initBreadcrumbs(el);
    });
  });
}
